import { render, staticRenderFns } from "./max-volume-cell.vue?vue&type=template&id=6cf3bbec&"
import script from "./max-volume-cell.vue?vue&type=script&lang=ts&"
export * from "./max-volume-cell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports